import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export const AdminQueue = ({ config }) => {
  const [data, setData] = useState(null);
  const [badgeSel, setBadgeSel] = useState({});

  const load = () => api.get("/directstay/admin/queue").then((r) => setData(r.data)).catch(() => setData({ pending_properties: [], pending_claims: [] }));
  useEffect(() => { load(); }, []);

  const verify = async (id, action) => {
    try {
      await api.post(`/directstay/admin/properties/${id}/verify`, { action, badges: badgeSel[id] || ["identity_verified", "contact_verified"] });
      toast.success(action === "publish" ? "Property published" : "Property " + action + "ed");
      load();
    } catch { toast.error("Action failed"); }
  };
  const decideClaim = async (id, decision) => {
    try { await api.post(`/directstay/admin/claims/${id}/decide`, { decision }); toast.success(`Claim ${decision}d`); load(); }
    catch { toast.error("Action failed"); }
  };
  const toggleBadge = (pid, b) => {
    const cur = badgeSel[pid] || ["identity_verified", "contact_verified"];
    setBadgeSel({ ...badgeSel, [pid]: cur.includes(b) ? cur.filter((x) => x !== b) : [...cur, b] });
  };

  if (!data) return <div className="py-10 text-center text-zinc-400">Loading queue…</div>;

  return (
    <div data-testid="admin-queue" className="space-y-8">
      <div className="text-sm text-zinc-500">{data.published_count} published properties on the network</div>
      <section>
        <h3 className="font-heading font-900 text-lg mb-3">Pending verification ({data.pending_properties.length})</h3>
        {data.pending_properties.length === 0 && <div className="text-sm text-zinc-400">Queue is clear.</div>}
        <div className="space-y-3">
          {data.pending_properties.map((p) => (
            <div key={p.id} data-testid={`pending-prop-${p.id}`} className="border border-zinc-300 bg-white p-4">
              <div className="font-heading font-900">{p.name} <span className="text-xs font-400 text-zinc-500">— {p.property_type?.replace(/_/g, " ")}, {p.location?.city}, {p.location?.state}</span></div>
              <div className="text-xs text-zinc-500 mt-1">Owner: {p.owner_email} · Submitted {new Date(p.created_at).toLocaleDateString()}</div>
              {p.description && <p className="text-sm text-zinc-600 mt-1 line-clamp-2">{p.description}</p>}
              <div className="flex flex-wrap gap-1.5 mt-2">
                {(config?.badges || []).map((b) => {
                  const sel = (badgeSel[p.id] || ["identity_verified", "contact_verified"]).includes(b);
                  return <button key={b} onClick={() => toggleBadge(p.id, b)} className={`text-[10px] px-2 py-1 border ${sel ? "bg-emerald-700 text-white border-emerald-700" : "border-zinc-300 text-zinc-500"}`}>{b.replace(/_/g, " ")}</button>;
                })}
              </div>
              <div className="flex gap-2 mt-3">
                <button data-testid={`publish-${p.id}`} onClick={() => verify(p.id, "publish")} className="bg-emerald-700 text-white text-xs font-700 uppercase px-4 py-2">Verify & publish</button>
                <button data-testid={`reject-${p.id}`} onClick={() => verify(p.id, "reject")} className="border border-red-300 text-red-600 text-xs font-700 uppercase px-4 py-2">Reject</button>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section>
        <h3 className="font-heading font-900 text-lg mb-3">Pending claims ({data.pending_claims.length})</h3>
        {data.pending_claims.length === 0 && <div className="text-sm text-zinc-400">No pending claims.</div>}
        <div className="space-y-3">
          {data.pending_claims.map((c) => (
            <div key={c.id} className="border border-zinc-300 bg-white p-4">
              <div className="font-heading font-900">{c.property_name}</div>
              <div className="text-xs text-zinc-500">{c.name} ({c.role_at_property}) · {c.email} · {c.phone}</div>
              {c.message && <p className="text-sm text-zinc-600 mt-1">{c.message}</p>}
              <div className="flex gap-2 mt-3">
                <button onClick={() => decideClaim(c.id, "approve")} className="bg-emerald-700 text-white text-xs font-700 uppercase px-4 py-2">Approve</button>
                <button onClick={() => decideClaim(c.id, "reject")} className="border border-red-300 text-red-600 text-xs font-700 uppercase px-4 py-2">Reject</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
